export const reportsSliceName = "reports"
